import { types } from 'mobx-state-tree'
import { categories } from '../api'

// TODO: Use the `CategoryModel` in `CategoriesStore.data`
const CategoryModel = types.model({
  id: types.number,
  description: types.string,
  created_at: types.string, // TODO: try types.Date
  updated_at: types.string,
  experiences_count: types.number,
  experiences: types.optional(types.frozen)
})

const CategoriesStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get () {
      categories().then(
        self.fetchCategories
      )
    },
    fetchCategories (categories) {
      self.data = categories
      self.loaded = true
    }
  })
).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get options () {
      let obj = {}
      return Object.keys(self.data).map((key) => {
        obj = self.data[key]
        return {
          label: obj.description,
          value: obj.id
        }
      })
    }
  })
)

export default CategoriesStore



// WEBPACK FOOTER //
// ./src/stores/CategoriesStore.js